import { Box } from '@wishket/design-system';

import NewLandingArticleItem from '../NewLandingArticle/NewLandingArticleItem';

import { NewLandingArticleItemProps } from '@/shared/types';

interface PersonalizedContentsProps {
  personalizedContents: NewLandingArticleItemProps[];
}

const PersonalizedContents = ({
  personalizedContents,
}: PersonalizedContentsProps) => {
  return (
    <Box
      className="grid grid-cols-1 gap-5 tablet:grid-cols-2 desktop:gap-6"
      data-testid="landing-personalized-contents-list"
    >
      {personalizedContents.map((content) => {
        const itemProps = {
          ...content,
          titleClassName: 'desktop:typo-subTitle2',
        };

        return (
          <Box
            className="rounded-3xl border border-w-gray-100 p-5 pb-4 desktop:p-6 desktop:pb-5"
            key={content.articleInfo.id}
          >
            <Box className="hidden desktop:block">
              <NewLandingArticleItem {...itemProps} imageSize="md" />
            </Box>
            <Box className="desktop:hidden">
              <NewLandingArticleItem {...itemProps} imageSize="sm" />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default PersonalizedContents;
